export var CdsPackageName;
(function(CdsPackageName) {
    /** Package required for premium plans */ CdsPackageName["Project"] = "ModProj";
    /** Package required for portfolios */ CdsPackageName["Roadmap"] = "Roadmap";
})(CdsPackageName || (CdsPackageName = {}));
/** List of CDS package names */ export const CdsPackageNamesList = [
    "ModProj",
    "Roadmap"
];
